import { Facebook, Instagram, BookOpen, Music2, Video } from 'lucide-react';
import { useSiteConfig } from '../../hooks/useSiteConfig';
import fallbackLogoFull from '../../assets/logo-full.jpg';

const socialIconMap: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  Facebook,
  Instagram,
  BookOpen,
  Music2,
  Video,
};

export default function FooterSection() {
  const siteConfig = useSiteConfig();
  const { footer, contact, site } = siteConfig;
  const logoFull = site.logoFull || fallbackLogoFull;

  return (
    <footer className="py-10 bg-deep-black border-t border-neon-cyan/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 mb-8">
          <img src={logoFull} alt={contact.companyName || site.title} className="h-12 md:h-14 object-contain" />
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="text-gray-500 text-sm">{footer.copyright}</p>
            <p className="text-gray-600 text-xs mt-1">對接顧問：{contact.consultant} · WhatsApp {contact.whatsappDisplay}</p>
            <p className="text-gray-600 text-xs mt-1">
              Powered by{" "}
              <a
                href="https://jkdcoding.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-neon-cyan transition-colors"
              >
                jkdcoding.com
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3">
            {footer.socials.map((social) => {
              const Icon = socialIconMap[social.icon] || Facebook;
              return (
                <a
                  key={social.id}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 border border-neon-cyan/15 rounded-full flex items-center justify-center text-gray-400 hover:text-neon-cyan hover:border-neon-cyan/50 hover:bg-neon-cyan/10 transition-all duration-300"
                  aria-label={social.platform}
                >
                  <Icon size={17} />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}
